let SwiperTop = new Swiper('.swiper--top', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 6000,
    loop:true,
    autoplay: {
      delay: 1,
    },
    mousewheel: {
      forceToAxis: true,
    },
    disableOnInteraction: true,
    slidesPerView:'auto',
    allowTouchMove: false,
});
